// A0 - Ünite 4: Articles (a/an/the) & Uçak İçi Eşyalar
// Hedef: A, An, The kullanımı, sayılabilir/sayılamaz isimler

export const A0_UNIT_4 = {
  'A0-U4-L1': {
    id: 'A0-U4-L1',
    title: 'A ve An Kullanımı',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 A ve AN Nedir?',
          explanation: 'A ve AN belirsiz artikel (article) olarak adlandırılır. "Bir" anlamına gelir ve sadece TEKİL sayılabilir isimlerle kullanılır.',
          formula: 'A/AN + Tekil Sayılabilir İsim'
        },
        {
          type: 'grammar',
          title: '📊 A vs AN Kuralı',
          table: {
            headers: ['Artikel', 'Kullanım', 'Örnek'],
            rows: [
              ['A', 'ÜNSÜZ sesle başlayan kelimelerden önce', 'a pilot, a seat, a flight'],
              ['AN', 'SESSİZ sesle başlayan kelimelerden önce', 'an exit, an airport, an airline']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 DİKKAT: Harfe değil, SESE bakın! "a university" (çünkü /juːnɪ.../ ünsüz sesle başlar), "an hour" (çünkü /aʊər/ sesli sesle başlar)'
        },
        {
          type: 'grammar',
          title: '🔊 Özel Durumlar',
          table: {
            headers: ['Kelime', 'Doğru', 'Açıklama'],
            rows: [
              ['university', 'a university', '/juː.../ ünsüz ses'],
              ['umbrella', 'an umbrella', '/ʌ.../ sesli ses'],
              ['hour', 'an hour', '/aʊə/ sesli ses (H sessiz)'],
              ['honest', 'an honest person', '/ɒnɪst/ sesli ses (H sessiz)'],
              ['European', 'a European', '/jʊərə.../ ünsüz ses']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { correct: 'a pilot', wrong: 'an pilot' },
            { correct: 'a flight', wrong: 'an flight' },
            { correct: 'an exit', wrong: 'a exit' },
            { correct: 'an airline', wrong: 'a airline' },
            { correct: 'a uniform', wrong: 'an uniform' },
            { correct: 'an announcement', wrong: 'a announcement' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'A veya AN yazın',
          sentences: [
            { text: '___ passenger', answer: 'a' },
            { text: '___ airport', answer: 'an' },
            { text: '___ emergency', answer: 'an' },
            { text: '___ seat', answer: 'a' },
            { text: '___ aisle', answer: 'an' },
            { text: '___ window', answer: 'a' },
            { text: '___ hour', answer: 'an' },
            { text: '___ uniform', answer: 'a' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"___ airline" - Doğru artikel hangisi?',
          options: ['a', 'an'],
          correctIndex: 1,
          explanation: 'Airline /eəlaɪn/ sesli sesle başlar, bu yüzden AN kullanılır.'
        },
        {
          type: 'errorCorrection',
          instruction: 'Yanlışları düzeltin',
          sentences: [
            { wrong: 'a exit', correct: 'an exit' },
            { wrong: 'an pilot', correct: 'a pilot' },
            { wrong: 'a announcement', correct: 'an announcement' }
          ]
        }
      ]
    }
  },

  'A0-U4-L2': {
    id: 'A0-U4-L2',
    title: 'THE Kullanımı',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 THE Nedir?',
          explanation: 'THE belirli artikel (definite article) olarak adlandırılır. Belirli, bilinen veya daha önce bahsedilen şeyler için kullanılır.',
          formula: 'THE + Belirli/Bilinen İsim (tekil veya çoğul)'
        },
        {
          type: 'grammar',
          title: '📊 THE Ne Zaman Kullanılır?',
          table: {
            headers: ['Durum', 'Örnek', 'Açıklama'],
            rows: [
              ['Tek olan şeyler', 'the sun, the captain', 'Bir tane var'],
              ['Daha önce bahsedilen', 'I see a man. The man is tall.', 'Artık biliniyor'],
              ['Belirli olan', 'the exit at the front', 'Hangi çıkış belli'],
              ['Sıfat + en üstün', 'the best airline', 'Superlative'],
              ['Sıra sayıları', 'the first row, the second exit', 'Ordinal numbers']
            ]
          }
        },
        {
          type: 'grammar',
          title: '🔊 THE Telaffuzu',
          table: {
            headers: ['Sonraki Ses', 'Telaffuz', 'Örnek'],
            rows: [
              ['Ünsüz ses', '/ðə/ ("ıđı")', 'the pilot /ðə ˈpaɪlət/'],
              ['Sesli ses', '/ðiː/ ("đi")', 'the exit /ðiː ˈeksɪt/']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'the captain', tr: 'kaptan (belirli, bir tane)' },
            { en: 'the emergency exit', tr: 'acil çıkış (belirli)' },
            { en: 'the first row', tr: 'birinci sıra' },
            { en: 'the cockpit', tr: 'kokpit (bir tane)' },
            { en: 'the safety demonstration', tr: 'güvenlik gösterimi' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'THE veya A/AN yazın',
          sentences: [
            { text: 'This is ___ captain speaking. (tek)', answer: 'the' },
            { text: 'Please fasten ___ seatbelt.', answer: 'your', note: 'possessive kullanılır' },
            { text: '___ emergency exit is at ___ front.', answers: ['The', 'the'] },
            { text: 'I need ___ blanket. (herhangi bir)', answer: 'a' },
            { text: 'Where is ___ toilet? (belirli)', answer: 'the' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"This is ___ captain speaking." Boşluğa ne gelir?',
          options: ['a', 'an', 'the', 'Artikel yok'],
          correctIndex: 2,
          explanation: 'Kaptan bir tane ve belirli olduğu için THE kullanılır.'
        }
      ]
    }
  },

  'A0-U4-L3': {
    id: 'A0-U4-L3',
    title: 'Artikel Kullanılmayan Durumlar',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Artikel KULLANILMAZ:',
          table: {
            headers: ['Durum', 'Örnek', 'Açıklama'],
            rows: [
              ['Genel çoğul isimler', 'Pilots fly planes.', 'Genel olarak pilotlar'],
              ['Sayılamaz isimler (genel)', 'Water is important.', 'Genel olarak su'],
              ['Öğün adları', 'breakfast, lunch, dinner', 'We serve dinner.'],
              ['Diller', 'English, Turkish', 'I speak English.'],
              ['Ülke/şehir adları', 'Turkey, Istanbul', 'Çoğu ülke ve şehir'],
              ['Sporlar', 'tennis, football', 'I play tennis.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 İSTİSNA: "the" bazı ülke adlarında kullanılır: the USA, the UK, the Netherlands, the Philippines'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri - Artikel YOK',
          items: [
            { en: 'We serve dinner at 19:00.', tr: 'Akşam yemeğini 19:00\'da servis ediyoruz.' },
            { en: 'Passengers must follow safety rules.', tr: 'Yolcular güvenlik kurallarına uymalı.' },
            { en: 'The flight is to Istanbul.', tr: 'Uçuş İstanbul\'a.' },
            { en: 'I speak English and Turkish.', tr: 'İngilizce ve Türkçe konuşuyorum.' }
          ]
        },
        {
          type: 'grammar',
          title: '📊 Karşılaştırma',
          table: {
            headers: ['Artikel VAR', 'Artikel YOK'],
            rows: [
              ['I need a coffee. (bir fincan)', 'Coffee is hot. (genel)'],
              ['The passengers in row 5', 'Passengers must fasten seatbelts. (genel)'],
              ['I had the breakfast on the plane.', 'I had breakfast. (genel)']
            ]
          }
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'Gerekli yere artikel yazın, gerekmiyorsa "-" yazın',
          sentences: [
            { text: '___ safety is important.', answer: '-' },
            { text: 'Please fasten ___ seatbelt.', answer: 'your' },
            { text: 'We serve ___ lunch at 12:00.', answer: '-' },
            { text: 'I speak ___ English.', answer: '-' },
            { text: '___ flight is to ___ London.', answers: ['The', '-'] }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"___ water is free on the flight." Boşluğa ne gelir?',
          options: ['A', 'An', 'The', 'Artikel yok (-)'],
          correctIndex: 3,
          explanation: 'Genel olarak sudan bahsedildiği için artikel kullanılmaz.'
        }
      ]
    }
  },

  'A0-U4-L4': {
    id: 'A0-U4-L4',
    title: 'Sayılabilir vs Sayılamaz İsimler',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Sayılabilir İsimler (Countable)',
          explanation: 'Sayılabilir isimler tek tek sayılabilir: 1 seat, 2 seats, 3 seats...',
          examples: [
            'a seat / seats',
            'a passenger / passengers',
            'an exit / exits',
            'a flight / flights',
            'a bag / bags'
          ]
        },
        {
          type: 'grammar',
          title: '📚 Sayılamaz İsimler (Uncountable)',
          explanation: 'Sayılamaz isimler tek tek sayılamaz. A/AN KULLANILMAZ!',
          examples: [
            'water (✗ a water)',
            'coffee (✗ a coffee - ama "a cup of coffee" olabilir)',
            'information (✗ an information)',
            'luggage/baggage (✗ a luggage)',
            'advice (✗ an advice)',
            'news (✗ a news)'
          ]
        },
        {
          type: 'tip',
          content: '💡 LUGGAGE ve BAGGAGE sayılamaz! "a piece of luggage" veya "a bag" kullanın.'
        },
        {
          type: 'grammar',
          title: '📊 Havacılıkta Önemli Sayılamaz İsimler',
          table: {
            headers: ['İngilizce', 'Türkçe', 'Doğru Kullanım'],
            rows: [
              ['luggage/baggage', 'bagaj', 'your luggage, a piece of luggage'],
              ['information', 'bilgi', 'some information, a piece of information'],
              ['equipment', 'ekipman', 'safety equipment'],
              ['weather', 'hava durumu', 'bad weather'],
              ['turbulence', 'türbülans', 'some turbulence'],
              ['food', 'yemek', 'some food, a meal']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Doğru vs Yanlış',
          items: [
            { correct: 'Please collect your luggage.', wrong: 'Please collect your luggages.' },
            { correct: 'I need some information.', wrong: 'I need an information.' },
            { correct: 'We are experiencing turbulence.', wrong: 'We are experiencing a turbulence.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'classify',
          instruction: 'Sayılabilir (C) veya Sayılamaz (U) olarak işaretleyin',
          items: [
            { word: 'seat', answer: 'C' },
            { word: 'water', answer: 'U' },
            { word: 'passenger', answer: 'C' },
            { word: 'luggage', answer: 'U' },
            { word: 'flight', answer: 'C' },
            { word: 'information', answer: 'U' },
            { word: 'exit', answer: 'C' },
            { word: 'turbulence', answer: 'U' }
          ]
        },
        {
          type: 'errorCorrection',
          instruction: 'Hataları bulun ve düzeltin',
          sentences: [
            { wrong: 'I need an information.', correct: 'I need some information.' },
            { wrong: 'Please check your luggages.', correct: 'Please check your luggage.' },
            { wrong: 'We have a turbulence.', correct: 'We have turbulence. / We are experiencing turbulence.' }
          ]
        }
      ]
    }
  },

  'A0-U4-L5': {
    id: 'A0-U4-L5',
    title: 'Uygulama: Uçak İçi Eşyalar',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'vocabulary',
          title: '✈️ Uçak İçi Eşyalar',
          words: [
            { en: 'seatbelt', tr: 'emniyet kemeri', article: 'a', example: 'Fasten your seatbelt.' },
            { en: 'life vest / life jacket', tr: 'can yeleği', article: 'a', example: 'The life vest is under your seat.' },
            { en: 'oxygen mask', tr: 'oksijen maskesi', article: 'an', example: 'An oxygen mask will drop.' },
            { en: 'overhead bin', tr: 'üst bagaj bölümü', article: 'an/the', example: 'Put your bag in the overhead bin.' },
            { en: 'tray table', tr: 'tepsi masası', article: 'a/the', example: 'Please fold the tray table.' },
            { en: 'armrest', tr: 'kol dayanağı', article: 'an/the', example: 'The armrest can be raised.' },
            { en: 'call button', tr: 'çağrı butonu', article: 'a/the', example: 'Press the call button.' },
            { en: 'reading light', tr: 'okuma lambası', article: 'a/the', example: 'Turn on the reading light.' },
            { en: 'blanket', tr: 'battaniye', article: 'a', example: 'Would you like a blanket?' },
            { en: 'pillow', tr: 'yastık', article: 'a', example: 'Here is a pillow for you.' }
          ]
        },
        {
          type: 'scenario',
          title: '🗣️ Senaryo: Eşya Tanımlama',
          dialogues: [
            {
              speaker: 'Yolcu',
              text: 'Where is the life vest?',
              translation: 'Can yeleği nerede?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'The life vest is under your seat.',
              translation: 'Can yeleği koltuğunuzun altında.'
            },
            {
              speaker: 'Yolcu',
              text: 'Can I have a blanket?',
              translation: 'Bir battaniye alabilir miyim?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'Of course. Here is a blanket and a pillow.',
              translation: 'Tabii ki. İşte bir battaniye ve bir yastık.'
            }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          sentences: [
            { text: 'Please put your bag in ___ overhead bin.', answer: 'the' },
            { text: 'Would you like ___ blanket?', answer: 'a' },
            { text: '___ life vest is under your seat.', answer: 'The' },
            { text: 'Press ___ call button if you need help.', answer: 'the' },
            { text: 'This is ___ emergency exit.', answer: 'an' }
          ]
        },
        {
          type: 'matching',
          instruction: 'Eşyaları Türkçeleriyle eşleştirin',
          pairs: [
            { left: 'seatbelt', right: 'emniyet kemeri' },
            { left: 'overhead bin', right: 'üst bagaj' },
            { left: 'life vest', right: 'can yeleği' },
            { left: 'tray table', right: 'tepsi masası' },
            { left: 'call button', right: 'çağrı butonu' }
          ]
        }
      ]
    }
  },

  'A0-U4-EXAM': {
    id: 'A0-U4-EXAM',
    title: '📝 Ünite 4 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 15,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: '"___ exit" - Doğru artikel hangisi?',
          options: ['a', 'an'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: '"___ pilot" - Doğru artikel hangisi?',
          options: ['a', 'an'],
          correctIndex: 0
        },
        {
          type: 'multipleChoice',
          question: '"___ hour" - Doğru artikel hangisi?',
          options: ['a', 'an'],
          correctIndex: 1,
          explanation: 'Hour /aʊə/ sesli sesle başlar (\'h\' sessiz), bu yüzden AN.'
        },
        {
          type: 'multipleChoice',
          question: '"This is ___ captain speaking." Boşluğa ne gelir?',
          options: ['a', 'an', 'the'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi sayılamaz isimdir?',
          options: ['seat', 'passenger', 'luggage', 'exit'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi DOĞRU?',
          options: ['I need an information.', 'I need informations.', 'I need some information.', 'I need a information.'],
          correctIndex: 2
        },
        {
          type: 'fillBlank',
          question: 'The life vest is under ___ seat.',
          answer: 'your'
        },
        {
          type: 'fillBlank',
          question: 'Would you like ___ blanket?',
          answer: 'a'
        }
      ]
    }
  }
};

export default A0_UNIT_4;
